module.exports = __webpack_public_path__ + "media/images/profit-down-b7d27b45356fe16a833bb54c0a08799d.svg";